import * as types from '@/constants/mutationTypes'

const state = {
  attachmentsList: {},
  attachmentsZip: {}
}
const getters = {
  attachmentsList: state => state.attachmentsList,
  attachmentsZip: state => state.attachmentsZip
}
const actions = {
  setAttachmentsList ({commit}, data) {
    commit(types.SET_ATTACHMENTS_LIST, {data})
  },
  setAttachmentsZip ({commit}, data) {
    commit(types.SET_ATTACHMENTS_ZIP, {data})
  }
}
const mutations = {
  [types.SET_ATTACHMENTS_LIST] (state, {data}) {
    state.attachmentsList = data
  },
  [types.SET_ATTACHMENTS_ZIP] (state, {data}) {
    state.setAttachmentsZip = data
  }}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Attachments/modules/store.js